import DocumentMeta from "component/design-system/DocumentMeta";

function withMetaData(WrappedComponent: any) {
  function HOC(props: any) {
    const { staticData, actualResponse } = props;

    let meta = null;
    if (staticData && staticData.meta) {
      const {
        title, description, keywords, robots,
      } = staticData.meta;

      meta = {
        title, description, keywords, robots,
      };
    } else if (actualResponse && actualResponse.landingPage && actualResponse.landingPage.metaTitle) {
      const {
        metaTitle, metaDescription, metaKeywords, bannerImages, responsiveBannerMedia, cmsImageUrls,
      } = actualResponse.landingPage;

      // Meta Image
      let metaImage = "";
      if (bannerImages?.desktopImage) {
        metaImage = `${process.env.NEXT_PUBLIC_CMS}/${bannerImages.desktopImage}`;
      } else if (responsiveBannerMedia?.desktop?.url) {
        metaImage = `${process.env.NEXT_PUBLIC_CMS}/${responsiveBannerMedia?.desktop?.url}`;
      } else if (cmsImageUrls && cmsImageUrls.length > 0) {
        // First image is always desktop top image
        // eslint-disable-next-line prefer-destructuring
        metaImage = `${process.env.NEXT_PUBLIC_CMS}/${cmsImageUrls[0]}`;
      }

      meta = {
        title: metaTitle,
        description: metaDescription,
        keywords: metaKeywords,
        robots: "all",
        image: metaImage,
      };
    }
    if (meta) {
      return (
        <>

          <DocumentMeta {...meta} showOgTags />
          <WrappedComponent {...props} />
        </>
      );
    }

    return <WrappedComponent {...props} />;
  }

  return HOC;
}

export default withMetaData;
